import React, { useState, useEffect } from "react";
import style from "./TableCellDropdown.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown} from "@fortawesome/free-solid-svg-icons";

export default function TableCellDropDown(props)
{
    let { choices, onUpdate } = props;

    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(props.value);

    useEffect(
        () => {
            setValue(props.value)
        },
        [props.value]
    );

    useEffect(() => {
        document.addEventListener(
            "keydown",
            () => {
                // escape
                if(event.keyCode !== 27) {
                    return;
                }

                setOpen(false);
            }
        );
    });

    let choiceElements = [];
    let hasSelected = false;
    let selectedText = '';
    for (let content in choices) {
        if (! choices.hasOwnProperty(content)) continue;

        let isSelected = choices[content] === value;
        if ((null === value || typeof value === 'undefined') && ! hasSelected) {
            isSelected = true;
        }

        choiceElements.push(
            <div onClick={() => { setValue(choices[content]); setOpen(false); onUpdate(choices[content]); }}
                 className={isSelected ? style.selected: ""}
                 key={"tableCellDropdown"+content}
            >
                {content}

            </div>
        );

        if (isSelected) selectedText = content;

        hasSelected = hasSelected || isSelected;
    }

    if (! hasSelected) {
        choiceElements.push(
            <div onClick={() => { setValue(value); setOpen(false); onUpdate(value); }}
                 className={style.selected}
                 key={"tableCellDropdownDefault"}
            >
                {value}
            </div>
        );
        selectedText = value;
    }

    return <div className={style.tableCellDropdown + " " + (open ? style.open : '')}>
        <button className={style.valueButton} onClick={() => setOpen(!open)}>
            {selectedText}
            <span className={style.dropDownIcon}>
                <FontAwesomeIcon icon={faChevronDown}/>
            </span>
        </button>
        <div className={style.list}>{choiceElements}</div>
    </div>
}
